import React, { Component } from 'react';

const formatTimer = (h, m, s) => {
  const hours = h > 9 ? h : `0${h}`;
  const minutes = m > 9 ? m : `0${m}`;
  const seconds = s > 9 ? s : s < 0 ? `0${s*-1}` : `0${s}`;
  return `${hours}:${minutes}:${seconds}`;
};

class Timer extends Component {
  constructor(props) {
    super(props);

    const formatted = formatTimer(0, 0, 0);
    const startTime = new Date(props.startTime).getTime();

    this.state = {
      hours: 0,
      minutes: 0,
      seconds: 0,
      formatted,
      startTime,
    };
  }

  componentDidMount() {
    this.start();
  }

  componentWillUnmount() {
    this.stop();
  }

  componentWillReceiveProps(props) {
    if (props.restart && !this.props.restart) {
      this.restart();
    }

    if (props.start && !this.props.start) {
      this.start();
    }

    if (props.stop && !this.props.stop) {
      this.stop();
      this.clear();
    }
  }

  start = () => {
    this.interval = setInterval(this.counter, 1000);
  };

  stop = () => {
    clearInterval(this.interval);
  };

  clear = (cb = () => {}) => {
    const formatted = formatTimer(0, 0, 0);
    this.setState({
      seconds: 0,
      minutes: 0,
      hours: 0,
      formatted,
    }, cb);
  };

  restart = () => {
    this.stop();
    this.clear(this.start);
  };

  counter = () => {
    const { startTime } = this.state;
    let seconds = Math.floor((Date.now() - startTime) / 1000).toFixed(0);
    let minutes = Math.floor(seconds / 60).toFixed(0);
    const hours = Math.floor(minutes / 60).toFixed(0);
    seconds = seconds < 60 ? seconds : seconds - (minutes * 60);
    minutes = minutes < 60 ? minutes : minutes - (hours * 60);
    const formatted = formatTimer(hours, minutes, seconds);

    this.setState(prevState => ({
      seconds,
      minutes,
      hours,
      formatted,
    }));
  };

  render() {
    const { formatted, seconds } = this.state;
    const sign = seconds < 0 ? 'minus' : 'plus';

    return (
      <span className={`seconds-counter-${sign}`}><i className="fa fa-clock hidden-xs"/> { formatted }</span>
    );
  }
}

export default Timer;
